import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-phase",
  templateUrl: "./phase.component.html",
  styleUrls: ["./phase.component.scss"],
})
export class PhaseComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
